import { useCallback, MouseEvent } from 'react';
import { useIsMobile } from '../../../../../utils/getIsMobile';
import { useExperimentFlag } from '../../../../../utils/useExperimentFlag';
import { IconBookmarkAction } from '../../../../icon/IconBookmarkAction';
import { IconBookmarkActionFilled } from '../../../../icon/IconBookmarkActionFilled';
import { IconLikeAction } from '../../../../icon/IconLikeAction';
import { IconLikeFilled } from '../../../../icon/IconLikeFilled';
import { Box } from '../../../../layout/Box';
import { Typography } from '../../../../typography/Typography';
import { isPostStatusValidForSave } from '../../../PostDetailsCard/parts/utils/isPostStatusValidForSave';
import { ReactionState } from '../../../types';
import { ViewsBadge } from '../ViewsBadge/ViewsBadge';
import { ActionsWrapper, Button, CardActionsWrapper, TextWrapper } from './styles';
import { CardActionsProps } from './types';

export const CardActions: React.FC<CardActionsProps> = ({
    post,
    index,
    onReaction,
    onBookmark,
    ...other
}) => {
    const isMobile = useIsMobile();
    const isViewsBadgeEnabled = Number(useExperimentFlag('show_views_badge')) === 1;

    const { text, reactionState, saved, publicStats } = post;

    const onLikeClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();

            onReaction({ postNumber: index, reactionState: ReactionState.LIKE });
        },
        [onReaction, index],
    );

    const onBookmarkClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();

            onBookmark?.();
        },
        [onBookmark],
    );

    return (
        <CardActionsWrapper {...other} isMobile={isMobile}>
            {isViewsBadgeEnabled && publicStats?.shows ? (
                <Box position="absolute" bottom={0} left={0}>
                    <ViewsBadge
                        views={publicStats.shows}
                        background="var(--content-overlay-medium)"
                    />
                </Box>
            ) : null}
            {text ? (
                <TextWrapper>
                    <Typography
                        variant="caption"
                        color="var(--always-white)"
                        width="100%"
                        lines={3}
                    >
                        {text}
                    </Typography>
                </TextWrapper>
            ) : null}
            <ActionsWrapper>
                <Button onClick={onLikeClick}>
                    {reactionState === 'like' ? (
                        <IconLikeFilled fontSize={16} color="var(--always-white)" />
                    ) : (
                        <IconLikeAction fontSize={16} color="var(--always-white)" />
                    )}
                </Button>
                {isPostStatusValidForSave(post.status) && !post.ownersData?.isOwner ? (
                    <Button onClick={onBookmarkClick}>
                        {saved ? (
                            <IconBookmarkActionFilled fontSize={16} color="var(--always-white)" />
                        ) : (
                            <IconBookmarkAction fontSize={16} color="var(--always-white)" />
                        )}
                    </Button>
                ) : null}
            </ActionsWrapper>
        </CardActionsWrapper>
    );
};
